import styled from 'styled-components';

import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { useFormController } from '@dreryk/react-common';

import { PatientRemovalDescriptionTextarea } from './PatientRemovalDescriptionTextarea';
import { PatientRemovalInfo } from './PatientRemovalInfo';
import { PatientRemovalReasonSelect } from './PatientRemovalReasonSelect';
import { PatientRemoveFormBean, PatientRemoveFormController } from './PatientRemoveForm.types';

const StyledForm = styled.form`
   display: flex;
   flex-direction: column;
   gap: 1em;
`;

StyledForm.displayName = 'StyledForm';

export type PatientRemoveFormRenderProps = Pick<PatientRemoveFormController, 'formState' | 'handleSubmit'>;

type PatientRemoveFormProps = {
   readonly patient: PatientSimple;
   readonly children: (renderProps: PatientRemoveFormRenderProps) => JSX.Element;
};

export const PatientRemoveForm = (props: PatientRemoveFormProps): JSX.Element => {
   const { register, handleSubmit, formState, watch } = useFormController<PatientRemoveFormBean>({
      removalReason: null,
      description: null,
   });

   const patientRemovalReason = watch('removalReason');

   return (
      <StyledForm noValidate>
         <PatientRemovalInfo patient={props.patient} />
         <PatientRemovalReasonSelect register={register} />
         <PatientRemovalDescriptionTextarea
            register={register}
            required={Boolean(patientRemovalReason?.descriptionRequired)}
         />

         {props.children({ formState: formState, handleSubmit: handleSubmit })}
      </StyledForm>
   );
};
